<script>
    import Mobilebtn from '../mobilebtn.svelte';
    import MobileFooter from '../../reusableitems/mobileFooter.svelte';
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';
    let main;
    let image;
    let text;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(main, image, [{filter: 'grayscale(100%)', duration: 1},
            {filter: 'grayscale(0%)', duration: 1}], 3);
        initializeGsapAnimation(main, text, [{y: '-46.477vw', duration: 1},
            {y: '46.477vw', duration: 1}], 3);
}
</script>
<section>
    <div class="maindiv" bind:this={main}>
        <div class="backimg" bind:this={image}>
            <img
                src="/images/createmain/fanfictionback.png"
                alt=""
                width="100%"
                height="100%"
            />
        </div>
        <div class="info" bind:this={text}>
            <p class="text1">Storytellers & Opus</p>
            <p class="heading">FANFICTION <br />WRITERS</p>
            <p class="text2" style="font-weight: 700;">
                We’re building a platform that makes producing movies and games
                just as much a collaborative process for everyone as fanfiction
                writing is. More importantly, the derivatives are just as real
                as the original. Fix that ending, join our governing council
                now!
            </p>
        </div>
        <div class="btn">
            <Mobilebtn
            bgcolor='white'
            txtcolor='black'
                width="56.308vw"
                text="Join Storytellers Governace Council"
                text2="(Fanfiction Seat)"
                state ="Storyteller"
            />
        </div>
        <div class="footer">
            <MobileFooter backClr='white' svgClr='black'/>
        </div>
    </div>
</section>

<style>
    .maindiv {
        position: relative;
        font-family: "Orbitron";
        z-index: 1;
    }
    .backimg {
        width: 100%;
        height: 216.355vw;
        filter: grayscale(0%);
    }
    p {
        margin: 0;
    }
    .info {
        position: absolute;
        left: 14.720vw;
        bottom: 0;
    }
    .text1 {
        color: white;
        font-weight: 400;
        font-size: 3.271vw;
    }
    .heading {
        color: #a53bd6;
        font-weight: 900;
        font-size: 9.346vw;
    }
    .text2 {
        color: white;
        margin-top: max(53.972vw, 24.946vh);
        font-weight: 400;
        font-size: 2.804vw;
        line-height: 4.414vw;
        letter-spacing: 0.09em;
        width: 68.224vw;
    }
    .btn {
        position: absolute;
        bottom: max(23.364vw, 10.799vh);
        left: 21.846vw;
    }
    .footer{
        position: absolute;
        bottom: 0;
        width: 100vw;
    }
</style>
